import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { CoreService, CustomerUser } from '../services/core.service';
import { TournamentsService } from './../tournaments/services/tournaments.service';
declare let $;
declare let SetLanguage: any;
@Component({
    selector: 'comp_payout_modal',
    templateUrl: './payout_modal.html',
})
export class PayoutModal implements OnInit {
    public init: boolean;
    constructor(public tournamentsService: TournamentsService, public coreService: CoreService) {}
    public ngOnInit() {
        if (this.init) {
            return;
        }
        this.init = true;
    }

    public PayoutModal_Button_Yes() {
        this.coreService.configureClient();

        if (this.coreService.customerUser.TerminalBalance != '0.00') {
            this.tournamentsService.Terminal_Balance_Change(
                this.coreService.customerUser.TerminalBalance,
                'decrease',
                $('input[name="__RequestVerificationToken"]').val(),
            );

            let thiss = this;
            setTimeout(function() {
                thiss.coreService.configureClient();
            }, 1500);
        }
    }
    public PayoutModal_Button_No() {
        $('#PayoutModal').modal('hide');
    }
}
